export const labels = ["Initial Inputs", "Custom Features", "Feature Details", "Formatting and Output"];
export const formatTemplateLabels = [
  "Create New",
  "Template Slides",
  "Content Framing",
  "Colors",
  "Numerical Selections",
  "Edit Approvals",
];

export const formatTemplateStepSize = [1, 1.3, 0.7, 0.8, 1.8, 0.9];
